/*
 * Frases para el carrusel de citas.
 *
 * Cada entrada es una frase con autor opcional.
 */

const QUOTES = [
  {
    text: "Como el primer sorbo de café por la mañana, así es nuestro amor: cálido, profundo y nuestro.",
    author: "Tati & Junior\nAmantes del buen café"
  },
  {
    text: "Contigo entendí que el amor no era encontrar un destino, sino tener a quién llamar hogar en cada camino. ",
    author: "Tati & Junior \n Viajeros del mundo"
  },
  {
    text: "Ni la película más hermosa podría contar todo lo que siento cuando me miras como si aún fuera la primera vez.",
    author: "Tati & Junior \n Cineastas anónimos"
  },
  {
    text: "En un mundo lleno de ruido, tú sigues siendo la calma que encuentro en medio de todas mis mareas.",
    author: "Tati & Junior \n Adictos al mar"
  },
  {
    text: "Si pudiera detener el tiempo en un instante, sería en uno de esos atardeceres donde tu mano y la mía entendieron que ya eran hogar.",
    author: "Tati & Junior \n Coleccionistas de atardeceres"
  },
  {
    text: "Hay amores que brillan un momento… y luego está el nuestro, que aprendió a quedarse como la luna en el cielo.",
    author: "Tati & Junior \n Admiradores de la luna"
  }
];

export default QUOTES;